/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';

export const GradesValidator = Yup.object({
  grade: Yup.string().max(255).required('Grade is required'),
  teacher: Yup.string().max(255).required('Teacher name is required')
});
